import isEqual from "lodash/isEqual";

export const isDeepEqual = (a: unknown, b: unknown) => {
  return isEqual(a, b);
};
